export default __webpack_public_path__ + "static/media/bg_pelatihan_mobile.2ddcaba7.webp";